import React, {useEffect, useRef} from 'react';

export default function GoogleMapView({mapUrl, open, onClose}) {
    const iframeRef = useRef(null);

    useEffect(() => {
        const iframe = iframeRef.current;
        if (iframe) {
            iframe.onload = () => console.log('Map loaded');
        }
    }, []);

    if (!open) return null;

    return (
        <div className="gmap-overlay">
            <div className="gmap-container">
                <iframe
                    ref={iframeRef}
                    title="Google Map"
                    src={mapUrl}
                    allowFullScreen
                    loading="lazy"
                    style={{border: 0, width: '100%', height: '100%'}}></iframe>

                <button className="gmap-close" onClick={onClose}>
                    <img src="/bw_image/ic_close.png" alt="close" />
                </button>
            </div>
        </div>
    );
}
